module.exports = __webpack_public_path__ + "img/LogoOnly.41f2279e.png";